import {
  useQuery,
  useMutation,
  useQueryClient,
  type UseQueryResult,
} from '@tanstack/react-query'
import { wasteCategoriesApi } from '@/lib/api'
import type { WasteCategory } from '@/types'

export const wasteCategoryKeys = {
  all: ['waste-categories'] as const,
  list: () => [...wasteCategoryKeys.all, 'list'] as const,
  detail: (id: number) => [...wasteCategoryKeys.all, 'detail', id] as const,
}

export function useWasteCategories(): UseQueryResult<WasteCategory[]> {
  return useQuery({
    queryKey: wasteCategoryKeys.list(),
    queryFn: async () => {
      const res = await wasteCategoriesApi.list()
      return res.data
    },
    staleTime: 1000 * 60 * 10,
  })
}

export function useCreateWasteCategory() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: { name: string; is_active?: boolean }) =>
      wasteCategoriesApi.create(data).then((r) => r.data),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: wasteCategoryKeys.list() }),
  })
}

export function useUpdateWasteCategory() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: { name: string; is_active?: boolean } }) =>
      wasteCategoriesApi.update(id, data).then((r) => r.data),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: wasteCategoryKeys.list() }),
  })
}

export function useDeleteWasteCategory() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => wasteCategoriesApi.delete(id),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: wasteCategoryKeys.list() }),
  })
}
